import * as ActionMessage from "./Action";

export default {
  ...ActionMessage,
};
